import { render, staticRenderFns } from "./PayrollExpensesOverTimeChart.vue?vue&type=template&id=2df4cca9&scoped=true"
import script from "./PayrollExpensesOverTimeChart.vue?vue&type=script&lang=js"
export * from "./PayrollExpensesOverTimeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df4cca9",
  null
  
)

export default component.exports